import { Radio, RadioGroup as MuiRadioGroup } from '@mui/material';

import { RadioIcon } from '@/components/icons/RadioIcon';

import type { TOption } from '@/types/common';

import { ButtonControl } from './ButtonControl';
import { FullWidthControl } from './FullWidthControl';
import type { TRadioGroupProps } from './types';

const controls = {
  fullWidth: FullWidthControl,
  button: ButtonControl,
};

export const RadioGroup = <POption extends TOption<string>>({
  variant,
  value,
  options,
  renderOption,
  onChange,
  ...props
}: TRadioGroupProps<POption>) => {
  const Control = controls[variant];

  return (
    <MuiRadioGroup
      value={value || ''}
      onChange={(event, newValue) => onChange(newValue as POption['value'])}
      {...props}
    >
      {options.map((option) => (
        <Control
          key={option.value}
          value={option.value}
          label={renderOption(option)}
          isSelected={option.value === value}
          control={<Radio icon={<RadioIcon />} checkedIcon={<RadioIcon checked />} />}
          disabled={option.disabled}
        />
      ))}
    </MuiRadioGroup>
  );
};
